import { v4 as uuid } from 'uuid';
import { PolicyTypeEnum } from './PolicyTypeEnum';

export interface IPolicyJacketUI {
  policyId: string;
  file: File | null;
  policyCategory: PolicyTypeEnum | null;
  jacketName: string | null;
  policyNumber: string | null;
  latestJacketLink: string | null;
}

export const constructNewPolicyJacketUI = ({
  policyId = uuid(),
  file = null,
  policyCategory = null,
  jacketName = null,
  policyNumber = null,
  latestJacketLink = null,
}: Partial<IPolicyJacketUI> = {}) => ({
  policyId,
  file,
  jacketName,
  policyNumber,
  latestJacketLink,
  policyCategory,
});
